<template>
<div>
 <div class="card rounded mt-4">
    <div class="card-header">
        <h5 class="text-center">Upcoming Events</h5>
    </div>
    <div class="card-body">
        
        <div class="table-responsive">
            <table class="table table-striped">
            <thead>
                <tr>
                    <th>Image</th>
                    <th>Title</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Place</th>
                    <th class="text-center">View</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="event in paginated" :key="event.id">
                    <td>
                        <img class="img img-fluid" style="width:50px; height:50px" :src="event.medias[0].path" alt="Image"/>
                    </td>
                    <td>{{ event.name }}</td>
                    <td>{{ parseDate(event.date) }}</td>
                    <td>{{ event.start.slice(0,5) }} - {{ event.end.slice(0,5) }}</td>
                    <td>{{ event.place }}</td>
                    <td class="text-center">
                      <a href="" class="btn btn-primary btn-sm" style="color:white" @click.prevent="viewEvents(event)">
                        more
                      </a>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>

    </div>
    <div class="card-footer text-center">
         <nav class="myNav hidden-xs" aria-label="Page navigation">
            <ul class="pagination">
                <li v-bind:class="[{disabled: !pagination.prevPage }]" class="active">
                    <a href="#" class="page-link" @click.prevent="substraction()">
                        <b>Previous</b>
                    </a>
                </li>

                <li class="page-item disabled">
                    <a class="page-link " href="#" style="color: black">
                        Page
                        <b>{{ pagination.currentPage }}</b>
                        of
                        <b>{{ pagination.page }}</b>
                    </a>
                </li>

                <li v-bind:class="[{disabled: !pagination.nextPage }]" class="active">
                    <a href="#" class="page-link" @click.prevent="addition()">
                        <b>Next</b>
                    </a>
                </li>

                <li class="page-item disabled">
                    <a class="page-link" href="#" style="color: black"> From
                        <b>{{ pagination.from}}</b> to
                        <b>{{ pagination.to}}</b> out of
                        <b>{{ pagination.total }}</b>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
 </div>

 <div class="modal" id="viewEvent">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">{{ event.name }}</h6>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
            <p><img class="img img-fluid" :src="event.image" alt="image"/></p>
            <p>{{ event.description }}</p>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer"></div>

    </div>
  </div>
 </div>

</div>
</template>
<script>
import EventServices from "../../services/EventServices";
import $ from 'jquery';
// import Events from '../Main/Events/Events';
export default {
    data() {
        return {
           filters: {},
           events: [],
           event:{
               image:'',
               description:'',
               name:''
           },
           pagination:{
                currentPage:1,
                nextPage:'',
                prevPage:'',
                total:'',
                from:'',
                to:'',
                page:'',
           },
           length:10,
        }
    },

    created() {
        const now =  Date.now();
        const lastMonth = now - 31*24*60*60*1000;

        this.filters.dateF= new Date(lastMonth).toISOString().slice(0,10);
        this.filters.dateT= new Date(now).toISOString().slice(0,10);

        this.getEvents().then((resp)=>{
            this.events = resp.data.data;
        });
    },

    methods: {

        viewModel(){
            $('#viewEvent').modal('show');
        },

        viewEvents(event){
           this.event.image = event.medias[0].path;
           this.event.description = event.description;
           this.event.name = event.name;
           this.viewModel();
        },

        parseDate(value) {
            let newDate;
            const date = new Date(value);
            newDate = date.getDate() + ' ' + this.toStringMonth(date.getMonth()) + ' ' + date.getFullYear();
            return newDate;
        },

        toStringMonth(num){
            switch (num+1) {
                case 1: return 'January';
                case 2: return 'February';
                case 3: return 'March';
                case 4: return 'April';
                case 5: return 'May';
                case 6: return 'June';
                case 7: return 'July';
                case 8: return 'August';
                case 9: return 'September';
                case 10: return 'October';
                case 11: return 'November';
                case 12: return 'December';
            }
        },

        async getEvents() {
            try {
                const responce = await EventServices.getEvents();
                return responce;
            } catch (e) {
                return e;
            }
        },

        setDate(range){
            const regex = /(.*)\/(.*)\/(.*)/;

            let dateParsed = range.start.match(regex);
            this.filters.dateF= dateParsed[3]+'-'+dateParsed[2]+'-'+ dateParsed[1];

            dateParsed = range.end.match(regex);
            this.filters.dateT= dateParsed[3]+'-'+dateParsed[2]+'-'+ dateParsed[1];

            this.getEvents().then((resp)=>{
                this.events = resp.data.data;
                document.body.scrollTop = 0;
            });
        },

        substraction(){
            if(this.pagination.currentPage <=  1){
                this.$toast.fire('Page Limit :', 'Sorry cant go further', 'warning');
            } else {
                --this.pagination.currentPage;
            }
        },

        addition(){
            if(this.pagination.currentPage == this.pagination.page){
                this.$toast.fire('Page Limit :', 'Sorry cant go further', 'warning');
            } else {
                ++this.pagination.currentPage;
            }
        },

        paginate(array, length, pageNumber){
            this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
            this.pagination.page = Math.ceil(array.length / length);
            this.pagination.total = array.length;

            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },

        resetPagination(){
            this.pagination.currentPage  = 1;
            this.pagination.prevPage = '';
            this.pagination.nextPage = '';
        },

    },

    computed: {
        filteredEvent(){
            return this.events;
        },

        paginated(){
            return this.paginate(this.filteredEvent, this.length, this.pagination.currentPage);
        },
    },
}
</script>
<style scoped>

.myNav ul {
    text-align:center;
    position: relative;
    display: inline-flex;
}

</style>